import apiService from './api.service';
import { logger } from '../utils/logger';
import { API_ENDPOINTS } from '@/constants/api.constants';
import type { ApiResponse } from '@/types/api.types';
import type { Manager } from '@/types/entities';

interface ErrorWithResponse {
    response?: {
        status?: number;
        data?: {
            message?: string;
        };
    };
    message: string;
}

export const ManagerService = {
    getAllManagers: async (): Promise<Manager[]> => {
        try {
            // Токены теперь в httpOnly cookies, они отправляются автоматически
            const { data: responseData } = await apiService.get<ApiResponse<Manager[]>>(
                `${API_ENDPOINTS.MANAGERS.BASE}`
            );

            return responseData.data;
        } catch (error) {
            const axiosError = error as ErrorWithResponse;
            logger.error('Failed to fetch managers:', {
                status: axiosError.response?.status,
                message: axiosError.response?.data?.message || axiosError.message
            });

            if (axiosError.response?.status === 401) {
                window.location.href = '/login';
            }
            throw error;
        }
    },

    getManagerById: async (id: number): Promise<Manager> => {
        try {
            // Токены теперь в httpOnly cookies, они отправляются автоматически
            const { data: responseData } = await apiService.get<ApiResponse<Manager>>(
                `${API_ENDPOINTS.MANAGERS.GET(id)}`
            );
            return responseData.data;
        } catch (error) {
            const axiosError = error as ErrorWithResponse;
            logger.error('Failed to fetch manager:', {
                status: axiosError.response?.status,
                message: axiosError.response?.data?.message || axiosError.message
            });

            if (axiosError.response?.status === 401) {
                window.location.href = '/login';
            }
            throw error;
        }
    },

    getManagerClub: async (managerId: number) => {
        try {
            // Токены теперь в httpOnly cookies, они отправляются автоматически
            const { data: responseData } = await apiService.get<ApiResponse<{
                id: number;
                name: string;
            }>>(
                `${API_ENDPOINTS.MANAGERS.BASE}/${managerId}/club`
            );
            return responseData.data;
        } catch (error) {
            const axiosError = error as ErrorWithResponse;
            logger.error('Failed to fetch manager club:', {
                status: axiosError.response?.status,
                message: axiosError.response?.data?.message || axiosError.message
            });

            if (axiosError.response?.status === 401) {
                window.location.href = '/login';
            }
            throw error;
        }
    }
};

export default ManagerService;
